export default __webpack_public_path__ + "static/media/Logo-justiciacriminal.d12725d5.svg";